var map = {
	"./Amethyst_City_1280.png": 7146,
	"./Amethyst_City_1920.png": 6909,
	"./Amethyst_City_640.png": 8305,
	"./Corruption_1280.png": 7517,
	"./Corruption_1920.png": 4105,
	"./Corruption_640.png": 57,
	"./Focus_1280.png": 7373,
	"./Focus_1920.png": 8719,
	"./Focus_640.png": 6898,
	"./Memory_1280.png": 5703,
	"./Memory_1920.png": 6168,
	"./Memory_640.png": 7253,
	"./Night_Skirmishes_1280.png": 5380,
	"./Night_Skirmishes_1920.png": 8013,
	"./Night_Skirmishes_640.png": 4875,
	"./Reach_1280.png": 1590,
	"./Reach_1920.png": 4243,
	"./Reach_640.png": 8985,
	"./Storm_1280.png": 8988,
	"./Storm_1920.png": 9480,
	"./Storm_640.png": 2014,
	"assets/visualarts/Amethyst_City_1280.png": 7146,
	"assets/visualarts/Amethyst_City_1920.png": 6909,
	"assets/visualarts/Amethyst_City_640.png": 8305,
	"assets/visualarts/Corruption_1280.png": 7517,
	"assets/visualarts/Corruption_1920.png": 4105,
	"assets/visualarts/Corruption_640.png": 57,
	"assets/visualarts/Focus_1280.png": 7373,
	"assets/visualarts/Focus_1920.png": 8719,
	"assets/visualarts/Focus_640.png": 6898,
	"assets/visualarts/Memory_1280.png": 5703,
	"assets/visualarts/Memory_1920.png": 6168,
	"assets/visualarts/Memory_640.png": 7253,
	"assets/visualarts/Night_Skirmishes_1280.png": 5380,
	"assets/visualarts/Night_Skirmishes_1920.png": 8013,
	"assets/visualarts/Night_Skirmishes_640.png": 4875,
	"assets/visualarts/Reach_1280.png": 1590,
	"assets/visualarts/Reach_1920.png": 4243,
	"assets/visualarts/Reach_640.png": 8985,
	"assets/visualarts/Storm_1280.png": 8988,
	"assets/visualarts/Storm_1920.png": 9480,
	"assets/visualarts/Storm_640.png": 2014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4844;